import { IFieldDisplayData } from "../../../../commonDataObjects/interfaces";
import { DateDisplay } from "../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { ArticleExtraData } from "../../../../../articlePage/stateInterfaces";
import { getTranslation } from "../../autoTickerRowWidget/autoTickerRowTranslations";
import { minutesDiff } from "./newsFlashAndTwentyFourSevenMobileComponenta";
import { getDevice } from "../../../../siteWidgets/videoPlayer/videoPlayerAds";

interface TickerSlotItemProps {
    article: ArticleExtraData
    tickerFieldsDisplaySettings: IFieldDisplayData
    isFirstInterval: boolean
    languageCode: string
    highlightingDuration: number
    mobileDisplayType:string
}

interface TickerSlotItemState {
    isExpandOpen: boolean
    shouldDisplayArticle: boolean
    isFirstRender: boolean
    shouldBePinkBg:boolean
}

export class TickerSlotItem extends React.Component<TickerSlotItemProps, TickerSlotItemState>{
    constructor(props) {
        super(props);
        this.state = {
            isExpandOpen: false,
            shouldDisplayArticle: true,
            isFirstRender: true,
            shouldBePinkBg:true
        }
    }

    private onSlotClickHandler = (e: React.MouseEvent) => {
        const { title } = this.props.article;
        const { isExpandOpen } = this.state;
        if ((e.target as HTMLButtonElement).id !== "ticker-button-share") {
            this.dispatchCustomEvent(title);
            this.setState({ isExpandOpen: !isExpandOpen });
        } else {
            this.openShare();
        }
    }

    private dispatchCustomEvent = (title: string) => {
        const { isExpandOpen } = this.state;
        document.dispatchEvent(
            new CustomEvent("newsFlashesTwentyFourSevenReadMoreChange",
                {
                    detail: {
                        action: isExpandOpen ? "Collapse" : "Expand",
                        label: title,
                    }
                }
            ))
    }

    private dispatchShareCustomEvent = (title: string) => {
        document.dispatchEvent(
            new CustomEvent("newsFlashesTwentyFourSevenShare",
                {
                    detail: {
                        label: title,
                    }
                })
        )
    }

    private openShare = async () => {
        const { article: { title, publishedLink } } = this.props;
        const shareData = { url: publishedLink, title: title };
        try {
            // @ts-ignore
            navigator.share(shareData);
            this.dispatchShareCustomEvent(title);
        } catch (error) {
            console.log("error with sharing function", error)
        }
    }

    componentDidMount() {
        if (this.state.isFirstRender) {
            this.firstRender();
            this.setState({ isFirstRender: false })
        }
    }

    private firstRender = () => {
        const { isFirstInterval, article, highlightingDuration } = this.props;
        const isNow = minutesDiff(article) === 0;
        const isUpToFiveMin = minutesDiff(article) < highlightingDuration;
        if (isFirstInterval) {
            isUpToFiveMin && this.setState({ shouldDisplayArticle: false });
            setTimeout(() => {
                this.setState({ shouldDisplayArticle: true })
            }, 3000)
            setTimeout(() => {
                this.setState({  shouldBePinkBg:false });
            }, 6000)
        } else {
            isNow && this.setState({ shouldDisplayArticle: false });
            setTimeout(() => {
                this.setState({ shouldDisplayArticle: true, shouldBePinkBg:true });
            }, 3000)
            setTimeout(() => {
                this.setState({  shouldBePinkBg:false });
            }, 6000)
        }
    }

    public render() {
        const { article, languageCode, highlightingDuration, mobileDisplayType } = this.props;
        const { title, dateUpdatedOnSite, plainText, roof, author } = article;
        const { isExpandOpen, shouldDisplayArticle, shouldBePinkBg } = this.state;
        const newItem = minutesDiff(article) < highlightingDuration;
        const isPublishedNow = newItem ? "now" : "";
        const newPublished = newItem && shouldBePinkBg && mobileDisplayType==="light" ? "newItem" : "";
        const isOpen = isExpandOpen ? "open" : "";
        const lang = languageCode ? languageCode.slice(0, 2) : "he";
        const date = newItem ? getTranslation(lang, "Now") : <DateDisplay date={dateUpdatedOnSite} isMinutesAgo={true} isArticle={true} />;
        const isAuthor = author && author.length > 0;
       const isLightMode = mobileDisplayType && mobileDisplayType==="light";
       const isAndroid = getDevice() === "android";
        return (
            <>
                {shouldDisplayArticle &&
                    <div className={`slotView ${isOpen} ${isPublishedNow} ${newPublished}`} onClick={this.onSlotClickHandler}>
                        {roof && !isLightMode && <div className="roofTitle">{roof}</div>}
                        <div className="textDiv">
                        {roof && isLightMode && <span className="roofTitle">{roof}</span>}
                          <div className="slotTitle">
                               {title}
                            </div>
                            <div className={`slotText ${isOpen ? "show" : ""}`}>
                                {plainText}
                                {isAuthor &&   <br/>}
                                {isAuthor &&  <b>{`(${author})`}</b>}
                            </div>
                        </div>
                        <div className="moreDetails" >
                            <div className="dateView">{date}</div>
                            <div className="buttonsWrapper">
                                <div className={`buttonShare ${isAndroid ? "android": ""}`} id="ticker-button-share" />
                                <div className="buttonExpand" />
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }
}